import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular-ivy";
import { AppModule } from './app/app.module';
import { AppConfig } from './app/shared/models/appconfig.model';
import 'whatwg-fetch';
import 'img-comparison-slider';

fetch('/appconfig.json')
  .then(response => response.json())
  .then(config => {
    if (!config) {
      throw new Error('Error loading appconfig.json');
    }

    if (config?.sentryDsn && config.sentryDsn !== "${sentryDsn}" && config.sentryDsn.trim() !== "") {
      const sentryConfig = {
        dsn: config?.sentryDsn,
        release: config?.releaseVersion,
        environment: config?.envName,
        integrations: [
          new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.routingInstrumentation,
          }),
          new Sentry.Replay({
            maskAllText: true,
            blockAllMedia: true,
          }),
        ],
        tracesSampleRate: config.envName === "Test" ? 1.0 :
                          config.envName === "Staging" ? 0.8 : 0.1,
        replaysSessionSampleRate: config.envName === "Test" ? 1.0 :
                                  config.envName === "Staging" ? 0.1 : 0.01,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event: Sentry.Event) {
          if (event.exception) {
            const error = event.exception.values?.[0];
            if (error?.value?.includes('ChunkLoadError') || 
                error?.value?.includes('Loading chunk')) {
              return null;
            }
          }
          return event;
        },
        beforeSendTransaction(event: Sentry.Event) {
          if (event.transaction?.includes('/auth-') || 
              event.transaction?.includes('/silent-redirect')) {
            return null;
          }
          return event;
        },
        initialScope: {
          tags: {
            component: "angular-frontend"
          },
          user: {
            id: undefined
          }
        }
      };

      try {
        Sentry.init(sentryConfig);
        
        Sentry.setContext("app", {
          name: "SituPortal",
          version: config?.releaseVersion
        });
      } catch (error) {
        console.warn('Failed to initialize Sentry:', error);
      }
    }

    if (config.production || config.production === "true" || config.envName === "Production") {
      enableProdMode();
    }

    window.appconfig = config;

    platformBrowserDynamic()
      .bootstrapModule(AppModule, {
        providers: [{ provide: LOCALE_ID, useValue: 'en-AU' }]
      })
      .catch(err => console.error(err));
  })
  .catch(err => console.error(err));


declare global {
  interface Window { appconfig?: AppConfig; }
}
